
export const htmlEncode = (s: string) => s
	.replaceAll(`&`, `&amp;`)
	.replaceAll(`<`, `&lt;`)
	.replaceAll(`>`, `&gt;`)
	.replaceAll(`'`, `&#39;`)
	.replaceAll(`"`, `&#34;`);
